module.exports = __webpack_public_path__ + "static/media/ZT3.6af17ebd.jpg";